import { STATS_REQUEST, STATS_REQUEST_DOWNLOAD_LINK } from '@/store/actions/stats';

import { GuidelinePhases } from '@/lib/guideline.js';


export default {
  name: 'statistics',
  components: {},
  props: [],
  data () {
    return {
      guidelinePhases: GuidelinePhases,
      dateFrom: null,
      dateTo: null,
      phase: null,
      stats: [],
    }
  },
  computed: {
    filterOptions() {
      return [
        { value: this.guidelinePhases.draft, label: this.$t('message.Guideline.phase0') },
        { value: this.guidelinePhases.submitted, label: this.$t('message.Guideline.phase10') },
        { value: this.guidelinePhases.formalCheckApproval, label: this.$t('message.Guideline.phase30') },
        { value: this.guidelinePhases.preApproved, label: this.$t('message.Guideline.phase40') },
        { value: this.guidelinePhases.uploadedForGpcReview, label: this.$t('message.Guideline.phase42') },
        { value: this.guidelinePhases.uploadGpcReviewed, label: this.$t('message.Guideline.phase44') },
        { value: this.guidelinePhases.uploadGpcReviewedEnd, label: this.$t('message.Guideline.phase46') },
        { value: this.guidelinePhases.uploadedForReview, label: this.$t('message.Guideline.phase50') },
        { value: this.guidelinePhases.uploadReviewed, label: this.$t('message.Guideline.phase60') },
        { value: this.guidelinePhases.uploadReviewedEnd, label: this.$t('message.Guideline.phase70') },
        { value: this.guidelinePhases.reviewByNationalDelegates, label: this.$t('message.Guideline.phase80') },
        { value: this.guidelinePhases.reviewedByNationalDelegates, label: this.$t('message.Guideline.phase90') },
        { value: this.guidelinePhases.reviewByNationalDelegatesEnd, label: this.$t('message.Guideline.phase100') },
        { value: this.guidelinePhases.gpcFinalApproval, label: this.$t('message.Guideline.phase102') },
        { value: this.guidelinePhases.gpcFinalHold, label: this.$t('message.Guideline.phase104') },
        { value: this.guidelinePhases.boardApproval, label: this.$t('message.Guideline.phase110') },
        { value: this.guidelinePhases.boardApprovalApproved, label: this.$t('message.Guideline.phase120') },
        { value: this.guidelinePhases.boardApprovalOnHold, label: this.$t('message.Guideline.phase130') },
        { value: this.guidelinePhases.finalPublish, label: this.$t('message.Guideline.phase140') },
      ];
    },
  },
  mounted () {

  },
  methods: {
    generateStatistics() {
      this.$validator.validate().then(result => {
        if (!result) {
          this.$swal({
            title: 'Error!',
            text: this.$t("message.Guideline.fillRequiredFields"),
            type: 'error',
            confirmButtonText: 'OK'
          });

          this.showValidateErrors = true;
        } else {
          this.$store.dispatch(STATS_REQUEST, {dateFrom: this.dateFrom, dateTo: this.dateTo, phase: this.phase}).then((response) => {
            this.stats.push(response.data);
          }).catch((error) => {
            this.handleUnauth(error.response.status);
            this.handleForbidden(error.response.status);
            this.handleUnprocessable(error.response);
          });
        }
      });
    },

    removeStats(key) {
      this.stats.splice(key, 1);
    },

    downloadStatistics() {
      let sid = [];

      this.stats.forEach(elem => {console.log(elem); sid.push(elem.stats.id)});

      this.$store.dispatch(STATS_REQUEST_DOWNLOAD_LINK, {sid: sid}).then((response) => {
        window.open(response.data.link);
      }).catch((error) => {
        this.handleUnauth(error.response.status);
        this.handleForbidden(error.response.status);
        this.handleUnprocessable(error.response);
      });
    }
  }
}
